var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcluir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "excluir",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.545,
    height: 23.539,
    viewBox: "0 0 21.545 23.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7",
    "data-name": "Grupo 7",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_11",
    "data-name": "Caminho 11",
    d: "M21.911,7.079h1.606V22.736a.805.805,0,0,0,.8.8H39.04a.805.805,0,0,0,.8-.8V7.079H41.85a.8.8,0,1,0,0-1.606H38.023A5.715,5.715,0,0,0,36.564,1.78,6.344,6.344,0,0,0,31.733,0,5.814,5.814,0,0,0,27.05,1.793a5.32,5.32,0,0,0-1.124,3.68H21.911a.8.8,0,1,0,0,1.606Zm6.343-4.256A4.306,4.306,0,0,1,31.72,1.606a4.853,4.853,0,0,1,3.653,1.258,4.162,4.162,0,0,1,1.03,2.61H27.531A3.792,3.792,0,0,1,28.254,2.824Zm9.983,4.256V21.933H25.123V7.079Z",
    transform: "translate(-21.108)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_12",
    "data-name": "Caminho 12",
    d: "M174.911,197.556a.805.805,0,0,0,.8-.8V187.52a.8.8,0,1,0-1.606,0v9.234A.805.805,0,0,0,174.911,197.556Z",
    transform: "translate(-166.882 -177.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_13",
    "data-name": "Caminho 13",
    d: "M282.578,197.556a.805.805,0,0,0,.8-.8V187.52a.8.8,0,1,0-1.606,0v9.234A.805.805,0,0,0,282.578,197.556Z",
    transform: "translate(-269.463 -177.898)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcluir);
export default __webpack_public_path__ + "static/media/excluir.e3e39415168513ae5b1652be242c15ec.svg";
export { ForwardRef as ReactComponent };